import classNames from 'classnames';
import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { dataList } from '../../../../store/location';
import { loadersByName } from '../../../../store/ui';
import Main from '../../shared/base/main';
import Loading from '../../shared/Loading';

import './index.scss';
import Product from '../Product';
import ProductList from '../ProductList';

const Location: FC<{ location: Location }> = ({ location }) => {
    const intl = useIntl();
    const listAllData = useSelector(dataList);
    const locationLoading = useSelector(loadersByName('location'));
    const productLoading = useSelector(loadersByName('product'));
    const [showList, setShowList] = useState(true);
    const { pathname } = location;
    const isProductPage = pathname.includes('/location/product');

    useEffect(() => {
        if (listAllData?.data?.count === 0) {
            setShowList(true);
        }
    }, [listAllData]);

    return (
        <Main
            breadcrumbs={{
                pageName: intl.formatMessage({ id: 'general.productName', defaultMessage: 'Product Finder' }),
            }}
            title={{
                title: intl.formatMessage({ id: 'location.title', defaultMessage: 'Product Finder' }),
            }}
            container={{
                classNamesContainer: classNames('location__container', {
                    ['location__container--fix-height']: !showList && !isProductPage,
                }),
            }}
        >
            {((locationLoading && !listAllData?.data?.count && !isProductPage) || (productLoading && !locationLoading)) && (
                <Loading relative />
            )}

            {isProductPage ? <Product location={location} /> : <ProductList showList={showList} setShowList={setShowList} />}
        </Main>
    );
};

export default Location;
